import {
  call,
  CallEffect,
  put,
  PutEffect,
  select,
  SelectEffect,
  takeLatest
} from 'redux-saga/effects'

import RolesApi from '../../api/RolesApi'
import Errors from '../../constants/Errors'
import localize from '../../features/Localize/localize'
import { startMicroApps } from '../../initMicroApps'
import { isCurrentlyMasquerading, isMasqueraderUser } from '../auth/selectors'
import actions, { types } from './actions'
import messageDispatcher from '../../features/Messages/redux/messageDispatcher'

export function * fetchRolesFromApi (): IterableIterator<
  SelectEffect |
  CallEffect |
  PutEffect
  > {
  try {
    // fetch account roles
    const isMasquerading = yield select(isCurrentlyMasquerading)
    const roles = yield call(RolesApi.fetchRoles, isMasquerading)
    yield put(actions.fetchRolesSuccess(roles))

    // fetch masquerader roles if user is a masquerader are any
    const isMasqueraderUserFlag = yield select(isMasqueraderUser)
    if (isMasqueraderUserFlag) {
      // avoid api exit if not a masquerader
      const masqueraderRoles = yield call(RolesApi.fetchRoles, isMasqueraderUserFlag)
      yield put(actions.fetchMasqueraderRolesSuccess(masqueraderRoles))
    }

    yield call(startMicroApps)
  } catch (err) {
    messageDispatcher.addError({
      text: Errors.defaultError(localize.translate),
      err
    })
  }
}
export default function * rolesSaga () {
  yield takeLatest(types.FETCH_ROLES, fetchRolesFromApi)
}
